export enum PermissionWebService {
  /** Výpis webových služeb  */
  WS_LIST = 'WS_LIST',

  /** Detail webové služby */
  WS_DETAIL = 'WS_DETAIL',
}
